import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { headerEmpresa } from "../../helpers/headerEmpresa";
import { getEmpresa } from "../../../services/empresaService";

async function bancosPDF(bancos) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const empresa = await getEmpresa();
  bancos = Array.isArray(bancos) ? bancos : [];

  const dados = bancos.map(banco => ([
    { text: banco.SEQ_BANCO ?? '', alignment: 'center' },
    { text: banco.BANCO ?? '' },
    { text: banco.DESCRICAO ?? '' },
  ]));

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [20, 90, 20, 40],

    // ✅ Cabeçalho padrão
    header: headerEmpresa(empresa),

    content: [
      {
        text: 'Cadastro de Bancos',
        fontSize: 18,
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 15],
      },
      {
        table: {
          headerRows: 1,
          widths: [60, 100, '*'],
          body: [
            [
              { text: 'Seq', style: 'tableHeader', alignment: 'center' },
              { text: 'Código Banco', style: 'tableHeader' },
              { text: 'Descrição', style: 'tableHeader' },
            ],
            ...dados,
          ],
        },
        layout: {
          fillColor: (rowIndex) => {
            if (rowIndex === 0) return '#eeeeee';
            return rowIndex % 2 === 0 ? '#fafafa' : null;
          },
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#cccccc',
          vLineColor: () => '#cccccc',
          paddingLeft: () => 6,
          paddingRight: () => 6,
          paddingTop: () => 4,
          paddingBottom: () => 4,
        },
      },
    ],

    footer: (currentPage, pageCount) => ({
      columns: [
        {
          text: `Gerado em: ${new Date().toLocaleDateString('pt-BR')}`,
          alignment: 'left',
          fontSize: 9,
          margin: [20, 0, 0, 0],
        },
        {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 0, 20, 0],
        },
      ],
    }),

    styles: {
      tableHeader: {
        bold: true,
        fontSize: 11,
      },
    },
  };

  pdfMake.createPdf(docDefinition).open();
}

export default bancosPDF;